import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tela_padrao_crud = _resolveComponent("tela-padrao-crud")!
  const _component_importacao_registros_excel_modal = _resolveComponent("importacao-registros-excel-modal")!
  const _component_engenharia_produto_modal = _resolveComponent("engenharia-produto-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tela_padrao_crud, {
      ref: "refCrudEngenhariaProduto",
      estrutura: _ctx.crudBase.estrutura,
      servicoAPI: _ctx.servicoEngenhariaProduto,
      "exibir-importacao": _ctx.state.exibirImportacaoExcel,
      "onUpdate:exibirImportacao": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.exibirImportacaoExcel) = $event)),
      onExibirModal: _ctx.exibirModal,
      onSincronizaTelaCrud: _ctx.sincronizaTelaCrud
    }, null, 8, ["estrutura", "servicoAPI", "exibir-importacao", "onExibirModal", "onSincronizaTelaCrud"]),
    _createVNode(_component_importacao_registros_excel_modal, {
      visivel: _ctx.state.exibirImportacaoExcel,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirImportacaoExcel) = $event)),
      empresa: _ctx.storeSistema.getters.codigoEmpresaOperacao()
    }, null, 8, ["visivel", "empresa"]),
    _createVNode(_component_engenharia_produto_modal, {
      visivel: _ctx.crudBase.exibirModal,
      "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.crudBase.exibirModal) = $event)),
      operacao: _ctx.crudBase.operacao,
      "onUpdate:operacao": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.crudBase.operacao) = $event)),
      onSincronizarRegistro: _ctx.sincronizarRegistro
    }, null, 8, ["visivel", "operacao", "onSincronizarRegistro"])
  ], 64))
}